function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
export var QuantitySelector = /*#__PURE__*/_createClass(
/**
 * Init needed events for quantity selector HTML elements from formular
 * @param {Node} prmQuantitySelector
 */
function QuantitySelector(prmQuantitySelector) {
  _classCallCheck(this, QuantitySelector);
  this.quantitySelector = prmQuantitySelector;
  this.min = parseFloat(this.quantitySelector.getAttribute('min') || this.quantitySelector.dataset.min);
  this.max = parseFloat(this.quantitySelector.getAttribute('max') || this.quantitySelector.dataset.max);
  this.step = parseFloat(this.quantitySelector.getAttribute('data-step'));
  this.buttons = this.quantitySelector.parentElement.querySelectorAll('button');
  _quantitySelectorEvent.call(this, this.quantitySelector);
});

/**
 * Init event on input and element sibling near to it (buttons)
 */
function _quantitySelectorEvent() {
  var _this = this;
  _disableButtons.call(this);
  this.quantitySelector.addEventListener('blur', function () {
    var value = _getNumberValue.call(_this);
    _this.quantitySelector.value = Math.max(value, _this.min);
    _this.quantitySelector.value = Math.min(value, _this.max);
    _disableButtons.call(_this);
  });
  this.buttons[0].addEventListener('click', function (event) {
    event.preventDefault();
    _decrement.call(_this, _this.step);
    _disableButtons.call(_this);
  });
  this.buttons[1].addEventListener('click', function (event) {
    event.preventDefault();
    _increment.call(_this, _this.step);
    _disableButtons.call(_this);
  });

  // Keyboard interaction 
  //(https://www.w3.org/TR/wai-aria-practices-1.1/#spinbutton)
  this.quantitySelector.addEventListener('keydown', function (event) {
    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowLeft':
        event.preventDefault();
        _decrement.call(_this, _this.step);
        _disableButtons.call(_this);
        break;
      case 'ArrowUp':
      case 'ArrowRight':
        event.preventDefault();
        _increment.call(_this, _this.step);
        _disableButtons.call(_this);
        break;
      case 'PageUp':
        event.preventDefault();
        _increment.call(_this, _this.step * 5);
        _disableButtons.call(_this);
        break;
      case 'PageDown':
        event.preventDefault();
        _decrement.call(_this, _this.step * 5);
        _disableButtons.call(_this);
        break;
      case 'Home':
        event.preventDefault();
        _decrement.call(_this, _this.max);
        _disableButtons.call(_this);
        break;
      case 'End':
        event.preventDefault();
        _increment.call(_this, _this.max);
        _disableButtons.call(_this);
        break;
    }
  });
}

/**
 * Decrement the quantity by a specific amount
 */
function _decrement(amount) {
  var value = _getNumberValue.call(this);
  this.quantitySelector.value = Math.max(value - amount, this.min);
}

/**
 * Increment the quantity by a specific amount
 */
function _increment(amount) {
  var value = _getNumberValue.call(this);
  this.quantitySelector.value = Math.min(value + amount, this.max);
}

/**
 * Disabled buttons to step up or step down quantitySelector's value
 */
function _disableButtons() {
  var value = _getNumberValue.call(this);
  switch (value) {
    case this.min:
      this.buttons[0].disabled = true;
      this.buttons[1].disabled = false;
      break;
    case this.max:
      this.buttons[0].disabled = false;
      this.buttons[1].disabled = true;
      break;
    default:
      this.buttons[0].disabled = false;
      this.buttons[1].disabled = false;
  }
}

/**
 * Return value with comma replace by point.
 * @returns {String}
 */
function _acceptComma(prmValue) {
  return prmValue.replace(/,/g, '.');
}

/**
 * Return the value of quantitySelector element passed as parameter
 * @returns {BigInt}
 */
function _getNumberValue() {
  return this.quantitySelector.value === '0' ? 0 : parseFloat(_acceptComma(this.quantitySelector.value)) || 1;
}